import { ComponentProps, FC } from "react";
import ShowViewButtonOverlay from "./ShowViewButtonOverlay";

type Props = {
  url: string;
  imageProps?: ComponentProps<"img">;
  showViewButton?: boolean;
};

const PromptMediaImageAndGifFilePreview: FC<Props> = (props) => {
  return (
    <div className="relative flex self-stretch">
      {props.showViewButton && <ShowViewButtonOverlay url={props.url} />}
      <img
        alt=""
        src={props.url}
        {...props.imageProps}
        className="max-h-[auto] w-full max-w-full overflow-hidden bg-white object-contain object-center"
        style={{
          ...props.imageProps?.style,
        }}
      />
    </div>
  );
};

export default PromptMediaImageAndGifFilePreview;
